import {ProductTypeEnum} from "../enums/Products/ProductTypeEnum";

const GetItemTypeName = (itemType: ProductTypeEnum) => {
    if (itemType === ProductTypeEnum.Product) {
        return "Product";
    }
    return "Service";
}

export const ProductHelper = {
    GetItemTypeName
}